import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import { PAinfoCollapsible } from './uikit2';

import {
  PAgkRefundPeriods,
  PAgkRefundOption,
  SelectSquare,
  PAgkRefundLine,
  CssTableFlag,
  CssTableCountry
} from "./ffr/PAgkRefund";

import merge from "deepmerge";

import PACollapse from "./PACollapse";

export const PAskuName = ({
      opened,
      handleInput = ()=>void(0),
      label = "Asset name",
      sku = {
        value: "my_project",
        shown: false
      },
      name = {
        value: "My Project",
        languages: false,
        content: ["My Project", "Мой проект", "Mon projet"]
      },
      localeList = ['English', 'Russian', 'Қазақша']
  }) => {

  const [shown, setShown] = useState(opened);

  const handleInp = (
    value
    // e: SyntheticInputEvent<HTMLInputElement>
    ) => {
    // debugger
    handleInput()
  };

  const setValueGeneralName = (value, sku) => {
    let date = new Date();
    let timestamp = date.getTime();
    sku = `${sku}_${timestamp}`;
    handleInp(value)
    // let newData = {
    //   data: {
    //     keyData: {
    //       general: {
    //         sku: {
    //           value: sku
    //         },
    //         name: {
    //           value: value
    //         }
    //       }
    //     }
    //   }
    // };

    // setState({
    //   ...merge({ ...state }, newData)
    // });
  };


  return (
<React.Fragment>


{shown && (
  <FormGroup label="SKU" indentation="md">
    <Input
      input={{
        // name: 'with-icon',
        value: sku.value,
        // extraLabel: this.currLocked ? "DEFAULT" : null
        onChange: handleInp
      }}
      offset="right"
      //   extra={
      //     <Icon
      //       name={this.currLocked ? "null" : "delete"}
      //       hoverable={true}
      //       onClick={e => this.handeCurrDel(this.id, e)}
      // />}
    />
  </FormGroup>
)}


  <FormGroup label="" style={{position: 'relative'}}>
      <div
        className="xsui-form-group__label"
        style={{
          position: "absolute",
          right: 0
        }}
      >
        <div className="xsui-form-group__label" style={{ textAlign: "right" }}>
          <button
            className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button--icon"
            type="button"
            style={{ color: "#747e8a" }}
            onClick={e => {
              setShown(!shown);
            }}
          >
            {/* <i
                                    className="xsui-icon xsui-icon-expand"
                                    style={{ fontSize: 24, color: "inherit" }}
                                  /> */}
            <span
              style={{
                backgroundColor: "#747e8a",
                color: "white",
                fontSize: "9px",
                borderRadius: 4,
                padding: "0.15em 0.3em 0.15em 0.3em",
                margin: "0.3em 0.6em 0 0"
              }}
            >
              SKU
            </span>
            {sku.value}
          </button>
        </div>
      </div>

      <PACollapse
        label={label}
        setValueGeneralName={setValueGeneralName}
        localeList = {localeList}
        // content={[
        //   name["value"],
        //   "Мой проект",
        //   "Mon projet"
        // ]}
        content={[...name['content']]}
      />
    </FormGroup>


</React.Fragment>



  );
};
